import '../assets/Tooltip-C-QZMStp.css';
import { options } from "floating-vue";
import { VTooltip, options as options2 } from "floating-vue";
options.themes.tooltip.html = false;
options.themes.tooltip.delay = { show: 500, hide: 200 };
options.themes.tooltip.distance = 10;
options.themes.tooltip["arrow-padding"] = 3;
export {
  VTooltip as default,
  options2 as options
};
//# sourceMappingURL=Tooltip.mjs.map
